import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './routes'
import './index.css'

ReactDOM.render(<Routes />, document.getElementById('root'));                      